import type { ReactNode } from "react";
import { Label } from "~/components/ui/label";
import { cn } from "~/lib/utils";

export interface FormFieldProps {
  label: string;
  htmlFor?: string;
  description?: string;
  error?: string | null;
  children: ReactNode;
  className?: string;
}

export function FormField({ label, htmlFor, description, error, children, className }: FormFieldProps) {
  return (
    <div className={cn("space-y-2", className)}>
      <Label htmlFor={htmlFor}>{label}</Label>
      {children}
      {description ? <p className="text-xs text-muted-foreground">{description}</p> : null}
      {error ? <p className="text-xs text-destructive">{error}</p> : null}
    </div>
  );
}
